import type { ProductListItemDto } from '@repo/api/web/models'

import { FavoritesService } from '../services/FavoritesService'

export const useFavoritesCore = () => {
  const alt = useAlt()
  const auth = useAuth()
  const authInteractive = useAuthInteractive()
  const request = useRequest()

  const service = alt.get(FavoritesService)

  async function toggle(product: ProductListItemDto) {
    if (!auth.support.checkAuth() || auth.support.checkIsAnonymous()) {
      authInteractive.openAuth()
      return
    }

    const productId = product.id
    if (!productId) return

    const isFavorite = product.isFavorite

    await request.send(async () => {
      if (isFavorite) {
        await service.remove(productId)
        product.isFavorite = false
      } else {
        await service.add(productId)
        product.isFavorite = true
      }
    })
  }

  return {
    toggle,
  }
}
